// Translations for IT, DE, FR
export const translations = {
  it: {
    // Navbar
    nav: {
      home: "Home",
      about: "Chi Siamo",
      menu: "Menu",
      gallery: "Galleria",
      contact: "Contatti",
      reserve: "Prenota"
    },
    // Hero
    hero: {
      welcome: "Benvenuti alla",
      title: "Trattoria",
      subtitle: "Da Daniele",
      description: "Un viaggio culinario attraverso i sapori autentici dell'Italia, nel cuore di Solothurn dal 2003.",
      cta: "Scopri il Menu",
      secondaryCta: "Prenota un Tavolo"
    },
    // About
    about: {
      subtitle: "Tradizione e Passione",
      title: "La Nostra Storia",
      paragraphs: [
        "Nel 2003, il giovane imprenditore Daniele ha deciso di mettersi in proprio e di offrire alla città di Solothurn una cucina italiana variegata e autentica.",
        "La Trattoria Pizzeria Da Daniele è da molti anni uno dei ristoranti più amati di Solothurn. Dalla selezione \"à la carte\" ai gustosi piatti di carne e pesce fino agli eccellenti menu del giorno, offriamo una deliziosa scelta per ogni palato.",
        "L'ospitalità e un'atmosfera rilassata e informale rendono questo ristorante un'esperienza speciale!"
      ],
      signature: "Benvenuto da Daniele",
      since: "Dal"
    },
    // Features
    features: {
      cuisine: { title: "Cucina Autentica", description: "Ricette tradizionali italiane preparate con ingredienti freschi e di qualità." },
      wine: { title: "Vini Selezionati", description: "Una ricca carta dei vini con le migliori etichette italiane." },
      family: { title: "Atmosfera Familiare", description: "Un ambiente accogliente dove sentirsi come a casa." },
      terrace: { title: "Terrazza Panoramica", description: "Grande terrazza nel Vigierhof per pranzi e cene all'aperto." }
    },
    // Menu Attuale
    menuAttuale: {
      badge: "Aktuell / Attuale",
      subtitle: "Le nostre specialità attuali",
      title: "Menu Attuale",
      validFor: "Valido per il",
      comingSoonTitle: "Presto Nuove Specialità",
      comingSoonText: "Stiamo preparando nuove proposte speciali per voi. Torna presto per scoprire i piatti del momento.",
      refresh: "Aggiorna menu",
      refreshing: "Aggiornamento...",
      lastUpdated: "Ultimo aggiornamento"
    },
    // Menu
    menu: {
      subtitle: "Le Nostre Specialità",
      title: "Il Menu",
      note: "Tutti i prezzi sono in CHF. IVA inclusa. Informazioni sugli allergeni disponibili su richiesta.",
      halfPizza: "Una mezza pizza costa CHF 2.- in meno • Pizza e Pasta senza Glutine disponibili",
      sides: "Contorni: Riso bianco, Risotto allo zafferano, Verdure, Spinaci, Patatine fritte, Nüdeli (Supplemento CHF 7.-)"
    },
    // Gallery
    gallery: {
      subtitle: "I Nostri Momenti",
      title: "Galleria"
    },
    // Testimonials
    testimonials: {
      subtitle: "Cosa Dicono di Noi",
      title: "Recensioni",
      rating: "su Lunchgate • recensioni verificate",
      source: "Recensioni verificate da Lunchgate.ch"
    },
    // Contact
    contact: {
      subtitle: "Vieni a Trovarci",
      title: "Contatti & Prenotazioni",
      address: "Indirizzo",
      phone: "Telefono",
      email: "Email",
      hours: "Orari",
      hoursTitle: "Orari di Apertura",
      hotKitchen: "Cucina calda dalle 11:30 alle 14:00 e dalle 17:30 alle 22:00",
      closed: "Chiuso",
      formTitle: "Prenota un Tavolo",
      reserveSubtitle: "Vivi un'esperienza gastronomica autentica. Riserva online in pochi click.",
      reserveButton: "Prenota Ora Online",
      reserveOr: "oppure",
      reserveCallUs: "Chiamaci direttamente",
      reserveModalTitle: "Prenota il tuo Tavolo",
      groupsTitle: "Gruppi numerosi o eventi privati",
      groupsText: "Hai un tavolo per più di 8 persone o vuoi organizzare un'occasione speciale? Contattaci direttamente.",
      formName: "Nome",
      formEmail: "Email",
      formPhone: "Telefono",
      formGuests: "Numero Ospiti",
      formDate: "Data e Ora Preferita",
      formMessage: "Messaggio",
      formPlaceholder: "Richieste speciali, allergie, occasioni particolari...",
      formSubmit: "Invia Richiesta",
      formSuccess: "Grazie!",
      formSuccessMsg: "La tua richiesta è stata inviata. Ti contatteremo presto."
    },
    // Footer
    footer: {
      description: "La Trattoria Pizzeria Da Daniele si trova nel cuore della città di Solothurn. Il ristorante italiano vi accoglie su due piani e su una grande terrazza nel Vigierhof.",
      menuTitle: "Menu",
      contactTitle: "Contatti",
      rights: "Tutti i diritti riservati."
    },
    // Days
    days: {
      monday: "Lunedì",
      tuesday: "Martedì",
      wednesday: "Mercoledì",
      thursday: "Giovedì",
      friday: "Venerdì",
      saturday: "Sabato",
      sunday: "Domenica"
    }
  },
  de: {
    nav: {
      home: "Home",
      about: "Über Uns",
      menu: "Speisekarte",
      gallery: "Galerie",
      contact: "Kontakt",
      reserve: "Reservieren"
    },
    hero: {
      welcome: "Willkommen bei",
      title: "Trattoria",
      subtitle: "Da Daniele",
      description: "Eine kulinarische Reise durch die authentischen Aromen Italiens, im Herzen von Solothurn seit 2003.",
      cta: "Speisekarte",
      secondaryCta: "Tisch Reservieren"
    },
    about: {
      subtitle: "Tradition und Leidenschaft",
      title: "Unsere Geschichte",
      paragraphs: [
        "Im Jahr 2003 entschloss sich der Jungunternehmer Daniele, sich selbstständig zu machen und der Stadt Solothurn eine abwechslungsreiche italienische Küche anzubieten.",
        "Die Trattoria Pizzeria Da Daniele gehört seit vielen Jahren zu den beliebtesten Restaurants in Solothurn. Von der \"à la Carte\" Auswahl über geschmackvolle Fleisch- und Fischgerichte bis zu ausgezeichneten Tagesmenüs bieten wir eine herrliche Auswahl für jeden Gaumen.",
        "Gastfreundschaft sowie eine entspannte und ungezwungene Atmosphäre machen dieses Restaurant zu einem besonderen Erlebnis!"
      ],
      signature: "Benvenuto da Daniele",
      since: "Seit"
    },
    features: {
      cuisine: { title: "Authentische Küche", description: "Traditionelle italienische Rezepte mit frischen Qualitätszutaten." },
      wine: { title: "Ausgewählte Weine", description: "Eine reichhaltige Weinkarte mit den besten italienischen Etiketten." },
      family: { title: "Familiäre Atmosphäre", description: "Eine einladende Umgebung, in der man sich wie zu Hause fühlt." },
      terrace: { title: "Panoramaterrasse", description: "Grosse Terrasse im Vigierhof für Mittag- und Abendessen im Freien." }
    },
    menuAttuale: {
      badge: "Aktuell / Attuale",
      subtitle: "Unsere aktuellen Spezialitäten",
      title: "Aktuelles Menu",
      validFor: "Gültig für den",
      comingSoonTitle: "Bald Neue Spezialitäten",
      comingSoonText: "Wir bereiten neue spezielle Vorschläge für Sie vor. Schauen Sie bald wieder vorbei, um die Gerichte des Moments zu entdecken.",
      refresh: "Menu aktualisieren",
      refreshing: "Aktualisierung...",
      lastUpdated: "Letzte Aktualisierung"
    },
    menu: {
      subtitle: "Unsere Spezialitäten",
      title: "Speisekarte",
      note: "Alle Preise in CHF. MwSt. inbegriffen. Informationen zu Allergenen auf Anfrage.",
      halfPizza: "Eine halbe Pizza kostet CHF 2.- weniger • Pizza und Pasta glutenfrei verfügbar",
      sides: "Beilagen: Riso bianco, Risotto allo zafferano, Gemüse, Blattspinat, Pommes frites, Nüdeli (Zulage CHF 7.-)"
    },
    gallery: {
      subtitle: "Unsere Momente",
      title: "Galerie"
    },
    testimonials: {
      subtitle: "Was unsere Gäste sagen",
      title: "Bewertungen",
      rating: "auf Lunchgate • verifizierte Bewertungen",
      source: "Verifizierte Bewertungen von Lunchgate.ch"
    },
    contact: {
      subtitle: "Besuchen Sie Uns",
      title: "Kontakt & Reservierung",
      address: "Adresse",
      phone: "Telefon",
      email: "E-Mail",
      hours: "Öffnungszeiten",
      hoursTitle: "Öffnungszeiten",
      hotKitchen: "Warme Küche von 11:30 bis 14:00 und 17:30 bis 22:00",
      closed: "Geschlossen",
      formTitle: "Tisch Reservieren",
      reserveSubtitle: "Erleben Sie ein authentisches gastronomisches Erlebnis. Reservieren Sie online in wenigen Klicks.",
      reserveButton: "Jetzt Online Reservieren",
      reserveOr: "oder",
      reserveCallUs: "Rufen Sie uns direkt an",
      reserveModalTitle: "Reservieren Sie Ihren Tisch",
      groupsTitle: "Grosse Gruppen oder private Events",
      groupsText: "Sie haben einen Tisch für mehr als 8 Personen oder möchten einen besonderen Anlass organisieren? Kontaktieren Sie uns direkt.",
      formName: "Name",
      formEmail: "E-Mail",
      formPhone: "Telefon",
      formGuests: "Anzahl Gäste",
      formDate: "Gewünschtes Datum und Uhrzeit",
      formMessage: "Nachricht",
      formPlaceholder: "Besondere Wünsche, Allergien, besondere Anlässe...",
      formSubmit: "Anfrage Senden",
      formSuccess: "Danke!",
      formSuccessMsg: "Ihre Anfrage wurde gesendet. Wir werden Sie bald kontaktieren."
    },
    footer: {
      description: "Die Trattoria Pizzeria Da Daniele befindet sich im Herzen der Stadt Solothurn. Das italienische Restaurant bedient Sie auf zwei Stockwerken und auf einer grossen Terrasse im Vigierhof.",
      menuTitle: "Menu",
      contactTitle: "Kontakt",
      rights: "Alle Rechte vorbehalten."
    },
    days: {
      monday: "Montag",
      tuesday: "Dienstag",
      wednesday: "Mittwoch",
      thursday: "Donnerstag",
      friday: "Freitag",
      saturday: "Samstag",
      sunday: "Sonntag"
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      about: "À Propos",
      menu: "Menu",
      gallery: "Galerie",
      contact: "Contact",
      reserve: "Réserver"
    },
    hero: {
      welcome: "Bienvenue à la",
      title: "Trattoria",
      subtitle: "Da Daniele",
      description: "Un voyage culinaire à travers les saveurs authentiques de l'Italie, au cœur de Soleure depuis 2003.",
      cta: "Découvrir le Menu",
      secondaryCta: "Réserver une Table"
    },
    about: {
      subtitle: "Tradition et Passion",
      title: "Notre Histoire",
      paragraphs: [
        "En 2003, le jeune entrepreneur Daniele a décidé de se mettre à son compte et d'offrir à la ville de Soleure une cuisine italienne variée et authentique.",
        "La Trattoria Pizzeria Da Daniele est depuis de nombreuses années l'un des restaurants les plus appréciés de Soleure. De la sélection \"à la carte\" aux délicieux plats de viande et de poisson, en passant par les excellents menus du jour, nous offrons un choix délicieux pour tous les palais.",
        "L'hospitalité et une atmosphère détendue et informelle font de ce restaurant une expérience spéciale!"
      ],
      signature: "Benvenuto da Daniele",
      since: "Depuis"
    },
    features: {
      cuisine: { title: "Cuisine Authentique", description: "Recettes italiennes traditionnelles préparées avec des ingrédients frais et de qualité." },
      wine: { title: "Vins Sélectionnés", description: "Une riche carte des vins avec les meilleures étiquettes italiennes." },
      family: { title: "Ambiance Familiale", description: "Un environnement accueillant où l'on se sent comme chez soi." },
      terrace: { title: "Terrasse Panoramique", description: "Grande terrasse dans le Vigierhof pour déjeuners et dîners en plein air." }
    },
    menuAttuale: {
      badge: "Actuel / Attuale",
      subtitle: "Nos spécialités actuelles",
      title: "Menu Actuel",
      validFor: "Valable pour le",
      comingSoonTitle: "Bientôt de Nouvelles Spécialités",
      comingSoonText: "Nous préparons de nouvelles propositions spéciales pour vous. Revenez bientôt pour découvrir les plats du moment.",
      refresh: "Actualiser le menu",
      refreshing: "Actualisation...",
      lastUpdated: "Dernière mise à jour"
    },
    menu: {
      subtitle: "Nos Spécialités",
      title: "Le Menu",
      note: "Tous les prix sont en CHF. TVA incluse. Informations sur les allergènes disponibles sur demande.",
      halfPizza: "Une demi-pizza coûte CHF 2.- de moins • Pizza et Pâtes sans gluten disponibles",
      sides: "Accompagnements: Riz blanc, Risotto au safran, Légumes, Épinards, Frites, Nüdeli (Supplément CHF 7.-)"
    },
    gallery: {
      subtitle: "Nos Moments",
      title: "Galerie"
    },
    testimonials: {
      subtitle: "Ce que disent nos clients",
      title: "Avis",
      rating: "sur Lunchgate • avis vérifiés",
      source: "Avis vérifiés de Lunchgate.ch"
    },
    contact: {
      subtitle: "Venez Nous Voir",
      title: "Contact & Réservations",
      address: "Adresse",
      phone: "Téléphone",
      email: "E-mail",
      hours: "Horaires",
      hoursTitle: "Heures d'Ouverture",
      hotKitchen: "Cuisine chaude de 11h30 à 14h00 et de 17h30 à 22h00",
      closed: "Fermé",
      formTitle: "Réserver une Table",
      reserveSubtitle: "Vivez une expérience gastronomique authentique. Réservez en ligne en quelques clics.",
      reserveButton: "Réserver Maintenant",
      reserveOr: "ou",
      reserveCallUs: "Appelez-nous directement",
      reserveModalTitle: "Réservez votre Table",
      groupsTitle: "Grands groupes ou événements privés",
      groupsText: "Vous avez une table pour plus de 8 personnes ou souhaitez organiser une occasion spéciale ? Contactez-nous directement.",
      formName: "Nom",
      formEmail: "E-mail",
      formPhone: "Téléphone",
      formGuests: "Nombre de Convives",
      formDate: "Date et Heure Souhaitées",
      formMessage: "Message",
      formPlaceholder: "Demandes spéciales, allergies, occasions particulières...",
      formSubmit: "Envoyer la Demande",
      formSuccess: "Merci!",
      formSuccessMsg: "Votre demande a été envoyée. Nous vous contacterons bientôt."
    },
    footer: {
      description: "La Trattoria Pizzeria Da Daniele se trouve au cœur de la ville de Soleure. Le restaurant italien vous accueille sur deux étages et sur une grande terrasse dans le Vigierhof.",
      menuTitle: "Menu",
      contactTitle: "Contact",
      rights: "Tous droits réservés."
    },
    days: {
      monday: "Lundi",
      tuesday: "Mardi",
      wednesday: "Mercredi",
      thursday: "Jeudi",
      friday: "Vendredi",
      saturday: "Samedi",
      sunday: "Dimanche"
    }
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      menu: "Menu",
      gallery: "Gallery",
      contact: "Contact",
      reserve: "Book"
    },
    hero: {
      welcome: "Welcome to",
      title: "Trattoria",
      subtitle: "Da Daniele",
      description: "A culinary journey through the authentic flavours of Italy, in the heart of Solothurn since 2003.",
      cta: "Discover the Menu",
      secondaryCta: "Book a Table"
    },
    about: {
      subtitle: "Tradition and Passion",
      title: "Our Story",
      paragraphs: [
        "In 2003, the young entrepreneur Daniele decided to go into business for himself and offer the city of Solothurn a varied and authentic Italian cuisine.",
        "Trattoria Pizzeria Da Daniele has been one of Solothurn's most beloved restaurants for many years. From the \"à la carte\" selection to flavourful meat and fish dishes and excellent daily menus, we offer a delightful choice for every palate.",
        "Hospitality and a relaxed, informal atmosphere make dining here a truly special experience!"
      ],
      signature: "Benvenuto da Daniele",
      since: "Since"
    },
    features: {
      cuisine: { title: "Authentic Cuisine", description: "Traditional Italian recipes prepared with fresh, high-quality ingredients." },
      wine: { title: "Selected Wines", description: "An extensive wine list featuring the best Italian labels." },
      family: { title: "Family Atmosphere", description: "A welcoming environment where you feel right at home." },
      terrace: { title: "Panoramic Terrace", description: "Large terrace in the Vigierhof for outdoor lunches and dinners." }
    },
    menuAttuale: {
      badge: "Current / Attuale",
      subtitle: "Our current specialities",
      title: "Current Menu",
      validFor: "Valid for",
      comingSoonTitle: "New Specialties Coming Soon",
      comingSoonText: "We are preparing new special proposals for you. Come back soon to discover the dishes of the moment.",
      refresh: "Refresh menu",
      refreshing: "Refreshing...",
      lastUpdated: "Last updated"
    },
    menu: {
      subtitle: "Our Specialities",
      title: "The Menu",
      note: "All prices are in CHF. VAT included. Allergen information available on request.",
      halfPizza: "A half pizza costs CHF 2.- less • Gluten-free Pizza and Pasta available",
      sides: "Side dishes: White rice, Saffron risotto, Vegetables, Spinach, French fries, Nüdeli (Supplement CHF 7.-)"
    },
    gallery: {
      subtitle: "Our Moments",
      title: "Gallery"
    },
    testimonials: {
      subtitle: "What They Say About Us",
      title: "Reviews",
      rating: "on Lunchgate • verified reviews",
      source: "Verified reviews by Lunchgate.ch"
    },
    contact: {
      subtitle: "Come Visit Us",
      title: "Contact & Reservations",
      address: "Address",
      phone: "Phone",
      email: "Email",
      hours: "Hours",
      hoursTitle: "Opening Hours",
      hotKitchen: "Hot kitchen from 11:30 to 14:00 and 17:30 to 22:00",
      closed: "Closed",
      formTitle: "Book a Table",
      reserveSubtitle: "Enjoy an authentic culinary experience. Book online in just a few clicks.",
      reserveButton: "Book Online Now",
      reserveOr: "or",
      reserveCallUs: "Call us directly",
      reserveModalTitle: "Book your Table",
      groupsTitle: "Large groups or private events",
      groupsText: "Have a table for more than 8 people or want to organize a special occasion? Contact us directly.",
      formName: "Name",
      formEmail: "Email",
      formPhone: "Phone",
      formGuests: "Number of Guests",
      formDate: "Preferred Date and Time",
      formMessage: "Message",
      formPlaceholder: "Special requests, allergies, special occasions...",
      formSubmit: "Send Request",
      formSuccess: "Thank you!",
      formSuccessMsg: "Your request has been sent. We will contact you soon."
    },
    footer: {
      description: "Trattoria Pizzeria Da Daniele is located in the heart of Solothurn. The Italian restaurant welcomes you on two floors and on a large terrace in the Vigierhof.",
      menuTitle: "Menu",
      contactTitle: "Contact",
      rights: "All rights reserved."
    },
    days: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday"
    }
  }
};

export const openingHoursData = [
  { dayKey: "thursday", hours: "09:00 - 00:00" },
  { dayKey: "friday", hours: "09:00 - 00:00" },
  { dayKey: "saturday", hours: "09:00 - 00:00" },
  { dayKey: "sunday", hours: "11:00 - 14:30, 17:30 - 23:30" },
  { dayKey: "monday", hours: "11:00 - 14:00, 17:30 - 23:30" },
  { dayKey: "tuesday", hours: "09:00 - 00:00" },
  { dayKey: "wednesday", hours: "09:00 - 00:00" }
];
